import React, { FC, useEffect } from 'react';
import { FallbackProps } from 'react-error-boundary';
import { Button, buttonShape, Text } from '../../ui';
import './error-fallback.scss';

const ErrorBoundary: FC<FallbackProps> = ({
  error,
  resetErrorBoundary,
}: FallbackProps) => {
  useEffect(() => {
    // send error to tech team
  }, [error]);

  return (
    <div id="error-falback-container">
      <div>
        <img src={process.env.PUBLIC_URL + '/images/bug.svg'} alt="bug svg" />
      </div>
      <Text>Something Went Wrong</Text>
      <Text>
        Occured error has been automatically send to Tech team, They will look
        into it Soon..
      </Text>
      <Button
        onClick={resetErrorBoundary}
        shape={buttonShape.box}
        label="Reload"
      />
    </div>
  );
};
export default ErrorBoundary;
